import r from "./index454.js";
import { resolveComponent as i, createBlock as n, openBlock as t, Transition as d, withCtx as c, createElementBlock as m, createCommentVNode as p, withKeys as f, createElementVNode as l, normalizeStyle as b, createVNode as u, renderSlot as y } from "vue";
import h from "./index231.js";
const v = ["data-component"], w = ["aria-labelledby", "aria-describedby"], g = { class: "relative h-40 p-8 m-8" }, x = { class: "relative flex flex-col px-20 pb-20 overflow-auto screen-m:px-40 screen-m:pb-40" };
function k(e, o, M, $, B, _) {
  const s = i("ms-close");
  return t(), n(d, {
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: c(() => [
      e.visible ? (t(), m("div", {
        key: 0,
        "data-component": e.$options.name,
        tabindex: "-1",
        class: "fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full duration-300 ease-in-out bg-anthracite bg-opacity-90 backdrop-filter backdrop-blur z-overlay-canvas-modal",
        onKeyup: o[1] || (o[1] = f((...a) => e.closeModal && e.closeModal(...a), ["esc"]))
      }, [
        l("div", {
          ref: "dialogRef",
          style: b({
            width: e.width,
            height: e.height
          }),
          role: "dialog",
          "aria-modal": "true",
          tabindex: "0",
          "aria-labelledby": e.labelledBy,
          "aria-describedby": e.describedBy,
          class: "flex flex-col max-w-full max-h-screen bg-white rounded screen-m:max-h-3/4 screen-m:max-w-3/4"
        }, [
          l("div", g, [
            l("button", {
              class: "absolute top-0 right-0 w-24 h-24",
              "aria-label": "Dialog schließen",
              type: "button",
              onClick: o[0] || (o[0] = (...a) => e.closeModal && e.closeModal(...a))
            }, [
              u(s)
            ])
          ]),
          l("section", x, [
            y(e.$slots, "default")
          ])
        ], 12, w)
      ], 40, v)) : p("", !0)
    ]),
    _: 3
  });
}
const z = /* @__PURE__ */ h(r, [["render", k]]);
export {
  z as default
};
